export default __webpack_public_path__ + "static/media/star.dfac123a.png";